/**
 * @file Move executor base
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { ExecutorBase } from './executor';
import * as moment from 'moment';
import { PROP_ORIGINAL_RESOURCE_OID } from '../../domain.service';
var MoveBase = /** @class */ (function (_super) {
    tslib_1.__extends(MoveBase, _super);
    /**
    * Creates an instance of MoveBase.
    * @param {string} name The name of executor
    * @param {string} label The label for the exectur (for localisation)
    * @param {ExecutorScope[]} scopes The executor has support for these scopes
    */
    function MoveBase(name, label, scopes, category, domainService, overlayService, dropTargetsService, diaglogService, translateService, userService, resourceService) {
        var _this = _super.call(this, name, label, scopes, 'move', category, domainService, overlayService, dropTargetsService, diaglogService, translateService, userService, resourceService) || this;
        // The success message for the move executors
        _this.successMessage = 'APP.EXECUTORS.MOVE_SUCCESS_MESSAGE';
        // The exactPositioning value for the move executors
        _this.exactPositioning = true;
        return _this;
    }
    /**
     * The business logic for this executor and is executed after the
     * validation step and before the finish step.
     * @param {ExecutorData} data The executor data
     * @returns {Promise<any>}
     */
    MoveBase.prototype.process = function (data) {
        var _this = this;
        // Your magic here inside an async promise
        return new Promise(function (resolve, reject) {
            _this.explodeExecutorData(data).forEach(function (slice) {
                _this.setPeriod(slice.item, slice.resource, slice.target);
            });
            _this.saveChanges(reject, resolve);
        });
    };
    /**
     * Change the start and finish of given item
     * @private
     * @param {Entity} item The entity
     * @param {Resource} resource The resource
     * @param {ExecutorTimeslot} target The target timeslot
     */
    MoveBase.prototype.setPeriod = function (item, resource, target) {
        // Get the current item start and finish
        var itemStart = moment(item['Start']);
        var itemFinish = moment(item['Finish']);
        // Keeps the duration between original start and finish
        var duration = itemFinish.diff(itemStart);
        // The following 'move' operations are supported:
        // - move inside timeslot using exact positionering (changing hours and minutes)
        // - move outside timeslot (change resource and date but not hours and minutes)
        if (this.movedInsideTimeslot(item, resource, target)) {
            // Update the new hours and minutes
            itemStart.hour(target.start.get('hour')).minute(target.start.get('minutes'));
        }
        else {
            // Set the resource (in case the plan items is moved to another resource)
            if (item['Resource'] !== resource) {
                item[PROP_ORIGINAL_RESOURCE_OID] = item['Resource_Oid']; // Met $OriginalResourceOid kunnen we  het planbord slim refreshen.
                item['Resource'] = resource;
            }
            // Update the new day, month and year
            itemStart.year(target.start.year()).month(target.start.month()).date(target.start.date());
        }
        // Add the duration to the start to create a new finish
        itemFinish = itemStart.clone().add(duration);
        // Update the item
        item['Start'] = itemStart.toDate();
        item['Finish'] = itemFinish.toDate();
    };
    /**
     * Validate the executor data
     * @protected
     * @param {ExecutorData} data The executor datea
     * @returns {Promise<any>}
     */
    MoveBase.prototype.validate = function (data) {
        var _this = this;
        // Make sure we have valid resources
        return this.validateResources(data.resources).then(function () {
            // Check if the source timeslot exists (only for Move executors!)
            return _this.validateTimeslot('source', data.source).then(function () {
                // Make sure the given items are of the correct type
                return _this.validateItems(data.items).then(function () {
                    // Check the target timeslot
                    return _this.validateTimeslots('targets', data.targets);
                });
            });
        });
    };
    /**
     * Used to check if the move happens inside or outside the timeslot based on target.start
     * and the given resource.
     * @protected
     * @param {Entity} item The plan item
     * @param {Entity} resource The (new) resource
     * @param {ExecutorTimeslot} target The new target
     * @returns {boolean}
     */
    MoveBase.prototype.movedInsideTimeslot = function (item, resource, target) {
        var itemStart = moment(item['Start']);
        var targetStart = target.start;
        if (item['Resource'] !== resource) {
            return false;
        }
        if (itemStart.dayOfYear() !== targetStart.dayOfYear()) {
            return false;
        }
        if (itemStart.year() !== targetStart.year()) {
            return false;
        }
        return true;
    };
    return MoveBase;
}(ExecutorBase));
export { MoveBase };
